import { IdentifiedStateValues, IDENTIFIED_STATE } from 'const'
import _ from 'lodash'
import { User } from 'types';
import { FEE_CATEGORY, FeeCategoryValue } from 'const';

export const isNullOrUndefined = (value: any) => {
  return value === null || value === undefined
}

export const editTel = (tel1: string | null = null, tel2: string | null = null, tel3: string | null = null) => {
  if (isNullOrUndefined(tel1)) return "-";
  if (tel1 === "") return "入力なし";
  return [tel1, tel2 || "", tel3 || ""].join("-");
}

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const convertKeyNamesToSnakeCase = (obj: { [key: string]: any }): any =>
  _.mapKeys(obj, (_v, k) => _.snakeCase(k))

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const convertKeyNamesToCamelCase = (obj: { [key: string]: any }): any =>
  _.mapKeys(obj, (_v, k) => _.camelCase(k))


export const isPermitted = (currentUser: User, lockedBy: string | null) => {
  if (!currentUser) return false;
  const { userId, groupName: groups} = currentUser
  if (groups.includes("supervisor")) return true;
  if (lockedBy == null) return false;
  return userId === lockedBy
};

export const getIdentifiesStateLabel = (identifiedValue: IdentifiedStateValues): string => {
  const identifiedState = Object.values(IDENTIFIED_STATE)
    .find(i => i.VALUE === identifiedValue)
  if (identifiedState) {
    return identifiedState.LABEL
  }
  return IDENTIFIED_STATE.UNIDENTIFIED.LABEL
}

 /**
  * 引数のフィー区分の値に対応するラベルを返す
  *
  * フィー区分は1,2の場合に「フィー」と返す必要がある
  * ※ 2は本来「販売特化」なのだが、管理画面ではまとめて「フィー」で表示して欲しいという要望があった
  *
  * @param fee_category フィー区分(undefined, null, 0, 1, 2)
  * @returns フィー 1, 2
  *          ノンフィー 0
  */
export const getFeeCategoryLabel = (fee_category: FeeCategoryValue | null | undefined) => {
  if (fee_category == null) return null;

  const non_fee = FEE_CATEGORY[0]
  const fee = FEE_CATEGORY[1]

  if(fee.value <= Number(fee_category)) {
    return fee.label;
  }

  return non_fee.label;
}

/* 日時区切りの「-」を「/」に変換 */
export const convertDateSeparator = (date: string | null) => {
  if (!date) return null
  return date.replaceAll('-', '/')
};

/* 日時区切りの「-」を「/」に変換、nullの場合は「-」を返却 */
export const convertDateSeparatorOrHyphen = (date: string | null) => {
  if (!date) return "-"
  return date.replaceAll('-', '/')
};
